// extracted by mini-css-extract-plugin
export default {"closeButton_button":"closeButton_button___SQr49"};